// Course completions are separate from the professional certifications.
// React-style credential IDs automatically receive Coursera verification links.
// Set verification to override that address for other credential providers.
export const training = [
  {
    title: 'Monitoring and Observability for Development and DevOps',
    issuer: 'IBM', date: 'February 2026', dateTime: '2026-02',
    credentialId: '7F7TDA5Q2A0J', verification: '',
    skills: ['Instana', 'System Monitoring'],
  },
  {
    title: 'The Bits and Bytes of Computer Networking',
    issuer: 'Google', date: 'August 2025', dateTime: '2025-08',
    credentialId: '4T0WAOTYZS4L', verification: '', skills: [],
  },
  {
    title: 'Technical Support Fundamentals',
    issuer: 'Google', date: 'July 2025', dateTime: '2025-07',
    credentialId: 'IIP08NIZJX9D', verification: '', skills: [],
  },
  {
    title: 'UR2PhD Undergraduate Research Training Course Participant',
    issuer: 'Computing Research Association', date: 'July 2025', dateTime: '2025-07',
    credentialId: '40294036106007', verification: '',
    skills: ['Research and Development (R&D)'],
  },
  {
    title: 'Data Science Orientation',
    issuer: 'Credly by Pearson', date: 'June 2025', dateTime: '2025-06',
    credentialId: '', verification: '', skills: [],
  },
  {
    title: 'What is Data Science?',
    issuer: 'IBM', date: 'June 2025', dateTime: '2025-06',
    credentialId: '4507LZOUFVLN', verification: '', skills: [],
  },
  {
    title: 'Version Control',
    issuer: 'Meta', date: 'June 2025', dateTime: '2025-06',
    credentialId: '0G8G8CM4TWP7', verification: '', skills: ['Git', 'Version Control'],
  },
  {
    title: 'Django Web Framework',
    issuer: 'Meta', date: 'June 2025', dateTime: '2025-06',
    credentialId: 'HOT3QOOA3ZW7', verification: '', skills: ['Django'],
  },
  {
    title: 'Python for Data Science, AI & Development',
    issuer: 'IBM', date: 'May 2025', dateTime: '2025-05',
    credentialId: 'DQQCMPX18J4V', verification: '', skills: ['Python', 'Pandas'],
  },
  {
    title: 'Introduction to Databases for Back-End Development',
    issuer: 'Meta', date: 'May 2025', dateTime: '2025-05',
    credentialId: '86U2EZCRVEO9', verification: '', skills: ['Database Management System (DBMS)', 'MySQL'],
  },
  {
    title: 'React Basics',
    issuer: 'Meta', date: 'May 2025', dateTime: '2025-05',
    credentialId: 'O05MCEG33UGA',
    verification: 'https://www.coursera.org/account/accomplishments/verify/O05MCEG33UGA',
    skills: ['React.js', 'Node.js'],
  },
];
